import React from "react";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_helpers";
import SVG from "react-inlinesvg";
import { InventoryEnum } from "../../../_helpers/InventoryEnums";

export default function CategoryModal({
  show,
  onHide,
  categoryName,
  selectedInventory,
  setSelectedInventory,
  handleItemCreate,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>ایجاد دسته بندی {categoryName} برای ؟</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"row mt-5"}>
          {InventoryEnum.map((inventory) => {
            return (
              <div key={inventory.value} className={"col-lg-4"}>
                <button
                  type={"button"}
                  className={`btn btn-outline-primary w-100 ${
                    inventory.value === selectedInventory
                      ? "bg-primary text-white"
                      : ""
                  }`}
                  onClick={() => {
                    console.log("HERE");
                    setSelectedInventory(inventory.value);
                  }}
                >
                  {selectedInventory === inventory.value && (
                    <span className="svg-icon svg-icon-md svg-icon-white">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Code/Done-circle.svg"
                        )}
                      />
                    </span>
                  )}
                  {inventory.text}
                </button>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type={"button"}
            onClick={onHide}
            className={"btn btn-light btn-elevate"}
          >
            لغو
          </button>
          <> </>
          <button
            type={"button"}
            onClick={handleItemCreate}
            className={"btn btn-primary btn-elevate"}
          >
            ایجاد دسته بندی
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
